import React, { useState, useEffect, useContext, useMemo } from "react";
import { GlobalContext } from "../../../App";
import "./popupselect.css";
import "leaflet/dist/leaflet.css";
import { ModifyMode, ViewMode } from '@nebula.gl/edit-modes';
import L from "leaflet";
import "leaflet.pattern";
import { addLegendToMap } from "./addLegend";

export default function Symbology({ }) {
  const {
    map,
    Canvas,
    setLayerData,
    layerData,
    vectors,
    setVectors,
    layerControls,
    SetLayers,      // April 5 - Shakshi Agarwal
  UsedLayers,          
  } = useContext(GlobalContext);
  const [category, setCategory] = useState("");
  const [geoJsonLayer, setGeoJsonLayer] = useState(null);
  const [selectedVector, setSelectedVector] = useState("");
  const [pointSize, setPointSize] = useState(35);
  const [lastSvgPath, setLastSvgPath] = useState(null);

  const availableVectors = useMemo(() => {
    const layerNames = new Set(vectors || []);

    if (layerControls?._layers?.length) {
      layerControls._layers
        .filter((obj) => obj.overlay)
        .forEach((obj) => {
          if (obj.name) layerNames.add(obj.name);
        });
    }

    if (UsedLayers && typeof UsedLayers === "object") {
      Object.keys(UsedLayers).forEach((name) => layerNames.add(name));
    }

    return Array.from(layerNames);
  }, [vectors, UsedLayers, layerControls]);

  // console.log("vectors", vectors);

  // useEffect(() => {
  //   if (layerControls && Canvas?.getLayers) {
  //     setVectors(Canvas.getLayers()); 
  //   }

  //   if (!selectedVector || !Canvas?.getLayerData) {
  //     setLayerData(null);
  //     return;
  //   }

  //   try {
  //     const layer = Canvas.getLayerData(selectedVector);
  //     console.log("Fetched Layer Data:", layer);
  //     if (!layer || !Array.isArray(layer.features)) {
  //       console.warn("Invalid or missing layer data for:", selectedVector);
  //       setLayerData(null);
  //       return;
  //     }

  //     setLayerData(layer);
  //   } catch (err) {
  //     console.error("Error fetching layer data:", err);
  //     setLayerData(null);
  //   }
  // }, [selectedVector]);
useEffect(() => {
  if (layerControls && Canvas?.getLayers) {
    setVectors(Canvas.getLayers()); 
  }

  if (!selectedVector) {
    setLayerData(null);
    return;
  }

  try {
    const layerEntry = Object.values(layerControls._layers).find(
      (l) => l.name === selectedVector || l.orgname === selectedVector
    );

    const layer = layerEntry?.layer?.toGeoJSON?.();

    // console.log("Layer from Leaflet:", layer);

    if (!layer?.features?.length) {
      console.warn("No features found for:", selectedVector);
      setLayerData(null);
      return;
    }

    setLayerData(layer);

  } catch (err) {
    console.error("Error fetching layer data:", err);
    setLayerData(null);
  }
}, [selectedVector, vectors]);
  useEffect(() => {
    if (!layerData?.name || !geoJsonLayer) return;

    if (!vectors.includes(selectedVector)) {
      console.log(
        `Layer ${selectedVector} no longer in vectors. Removing geoJsonLayer.`
      );
      map.removeLayer(geoJsonLayer);
      setGeoJsonLayer(null);
      removeOldPaths(); // Optional
    }
  }, [vectors, layerData, geoJsonLayer, map]);


  
  useEffect(() => {
    if (layerData?.features?.length > 0) {
      // console.log("Layer Data:", layerData);   

      const firstType = layerData.features[0].geometry.type;
      const cat = getGeometryCategory(firstType);
      // console.log("Detected Geometry Type:", firstType);           
      // console.log("Normalized Category:", cat);                  

      setCategory(cat);
    }
  }, [layerData]);

  // useEffect(() => {
  //   if (lastSvgPath && geoJsonLayer) {
  //     handleSvgClick(lastSvgPath);
  //   }
  // }, [pointSize]);

  //The above useEffect is changed by Shakshi Agarwal on 3 April 2026 to this below new useEffect

  useEffect(() => {
    if (lastSvgPath && layerData?.features?.length) {
      handleSvgClick(lastSvgPath);
    }
  }, [pointSize]);

  

  // April 5 - Shakshi Agarwal
useEffect(() => {
  const handleLayerRemoved = () => {
    // When any layer changes, check if our symbology layer's vector is gone
    if (selectedVector && window.__symbologyLayers?.[selectedVector]) {
      const stillExists = Canvas?.getLayers?.()?.includes(selectedVector);
      if (!stillExists) {
        const old = window.__symbologyLayers[selectedVector];
        if (map && map.hasLayer(old)) map.removeLayer(old);
        delete window.__symbologyLayers[selectedVector];
      }
    }
  };

  window.addEventListener("layersCleared", handleLayerRemoved);
  return () => window.removeEventListener("layersCleared", handleLayerRemoved);
}, [selectedVector, map, Canvas]);


  const svgFiles = {
    Polygon: [
      "AOI.svg",
      "gradient_plasma.svg",
      "hashed_black.svg",
      "outline_blue.svg",
      "outline_green.svg",
      "outline_red.svg",
      "128_Restricted_Area.svg",
      "Area.svg",
      "OFZ.svg",
      "primary_areas.svg",
      "simple_blue_fill.svg",
      "simple_green_fill.svg",
      "simple_red_fill.svg",
    ],
    Line: [
      // "air quality station.svg",
      // "arrow 02.svg",
      // "Arrow.svg",
      // "cave.svg",
      "centreline.svg",
      "construction_lines.svg",
      "dash_black.svg",
      "dash green.svg", // Add the new files here
      // "effect emboss.svg",
      // "effect neon.svg",
      // "pattern circles.svg",
      // "runway.svg",
      "scale_break.svg",
      "simple blue line.svg",
      "simple green line.svg",
      // "topo main road.svg",
      // "topo railway.svg",
      // "topo road.svg",
      // "topo steps.svg",
      "wavy line.svg",
    ],
    Point: [
      "AD Heliport.svg",
      "Aerialway.svg",
      "Airfield.svg",
      "Airport.svg",
      "Alcohol-Shop.svg",
      "ARP.svg",
      "Avslutad observation.svg",
      "Bar.svg",
      "Barrier.svg",
      "Bicycle.svg",
      "Blood-Bank.svg",
      "Bus.svg",
      "Cafe.svg",
      "Car-Repair.svg",
      "Car.svg",
      "carto-point.svg",
      // "cat trail.svg",
      "Charging-Station.svg",
      "Circle 1.svg",
      "circle 4.svg",
      "circle 5.svg",
      "circle 6.svg",
      "College.svg",
      "Communications-Tower.svg",
      "control point 3.svg",
      "cross 1.svg",
      "cross 9.svg",
      "cross 10.svg",
      "Cross.svg",
      "Dam.svg",
      "dot_black.svg",
      "dot_white.svg", 
      "dot_blue.svg",
      "dot_green.svg",
      "dot_red.svg",
      "flagpole.svg",
      "hexagon 1.svg",
      "hexagon 2.svg",
      "hexagon 3.svg",
      "honeycomb faux 3d.svg",
      "Hospital.svg",
      "Industry.svg",
      "Information.svg",
      "multimedia.svg",
      "Obstruction.svg",
      "octagon 1.svg",
      "octagon 2.svg",
      "octagon 3.svg",
      "octagon 4.svg",
      "pattern dot black.svg",
      "pentagon 1.svg",
      "pentagon 2.svg",
      "pentagon 3.svg",
      "pentagon 4.svg",
      "Provpumpning eller infiltrationsförsök.svg",
      "shield disability.svg",
      "spot elevation.svg",
      "topo hospital.svg",
      "topo pop capital.svg",
      "topo pop city.svg",
      "topo pop house.svg",
      "topo pop village.svg",
      "triangle 1.svg",
      "triangle 3.svg",
      "Vattennivå bestämd, t ex i provtagningshål.svg",
      "water gauging station.svg",
      "square_corner_1.svg",
      "square_7.svg",
      "square_2.svg",
      "square_.svg",
      "Brunn.svg",
    ],
  };

  const publicSvgList = category
    ? svgFiles[category]?.map(
      (file) => `${process.env.PUBLIC_URL}/${category}/${file}`
    )
    : [];

  const getGeometryCategory = (type) => {
    if (type === "Polygon" || type === "MultiPolygon") return "Polygon";
    if (type === "LineString" || type === "MultiLineString") return "Line";
    if (type === "Point" || type === "MultiPoint") return "Point";
    return null;
  };

  // const getStyleForSvg = (svgFileName, geometryType) => {
  //   const color =
  //     svgFileName.match(/(red|blue|green|yellow|black|gray|purple)/i)?.[0] ||
  //     "#000";

  //   console.log("Applying style for:", svgFileName, "Geometry:", geometryType);

  //   if (geometryType === "Polygon" || geometryType === "MultiPolygon") {
  //     if (svgFileName.includes("fill")) {
  //       return {
  //         fillColor: color,
  //         color: "#000",
  //         weight: 2,
  //         fillOpacity: 1,
  //       };
  //     } else if (svgFileName.includes("outline")) {
  //       return {
  //         fill: false, // Ensure no fill
  //         color,
  //         weight: 2,
  //       };
  //     } else if (svgFileName.includes("AOI")) {
  //       return {
  //         fill: false,
  //         color: "purple",
  //         weight: 2,
  //       };
  //     } else if (svgFileName.includes("hashed_black")) {
  //       return {
  //         fill: false,
  //         color: "#000",
  //         weight: 2,
  //       };
  //     } else if (svgFileName.includes("primary_areas")) {
  //       return {
  //         fillColor: "gray",
  //         color: "#000",
  //         weight: 2,
  //         fillOpacity: 0.7,
  //       };
  //     } else if (svgFileName.includes("128_Restricted_Area")) {
  //       return {
  //         fill: false,
  //         color: "red",
  //         weight: 2,
  //       };
  //     } else if (svgFileName.includes("Area")) {
  //       return {
  //         fillColor: "#fc7c7c",
  //         color: "#ec2d34",
  //         weight: 2,
  //         fillOpacity: 0.6,
  //       };
  //     } else if (svgFileName.includes("gradient_plasma")) {
  //       return {
  //         fill: false,
  //         color: "#000",
  //         weight: 1,
  //       };
  //     }  else if (svgFileName.includes("OFZ")) {
  //       return {
  //         fillColor: "purple",
  //         color: "purple",
  //         weight: 2,
  //         fillOpacity: 0.5,
  //       };
  //     }

  //     // Default fallback style
  //     // Default fallback style
  //     return {
  //       fill: false,
  //       fillColor: "transparent",
  //       color: "#000",
  //       weight: 2,
  //     };
  //   }
  //   if (
  //     geometryType === "LineString" ||
  //     geometryType === "MultiLineString" ||
  //     geometryType === "Line" ||
  //     geometryType === "Polyine"
  //   ) {
  //     if (svgFileName.includes("centreline")) {
  //       return {
  //         color: "#D3D3D3",
  //         weight: 2,
  //         dashArray: "20, 10, 4, 12",
  //       };
  //     } else if (svgFileName.includes("construction_lines")) {
  //       return {
  //         color: "red",
  //         weight: 2,
  //       };
  //     } else if (
  //       svgFileName.includes("dash") &&
  //       svgFileName.includes("black")
  //     ) {
  //       return {
  //         color: "black",
  //         weight: 4,
  //         dashArray: "25, 18",
  //       };
  //     } else if (
  //       svgFileName.includes("dash") &&
  //       svgFileName.includes("green")
  //     ) {
  //       return {
  //         color: "green",
  //         weight: 4,
  //         dashArray: "25, 18",
  //       };
  //     } else if (svgFileName.includes("dash")) {
  //       return {
  //         color,
  //         weight: 2,
  //         dashArray: "25, 18",
  //       };
  //     } else if (svgFileName.includes("runway")) {
  //       return {
  //         color: "#541404",
  //         weight: 3,
  //         dashArray: "10, 10",
  //       };
  //     } else if (svgFileName.includes("scale_break")) {
  //       return {
  //         color: "#541404",
  //         weight: 4,
  //       };
  //     } else if (svgFileName.includes("simple line")) {
  //       return {
  //         color,
  //         weight: 3,
  //       };
  //     } else if (svgFileName.includes("wavy line")) {
  //       return {
  //         color: "#000",
  //         weight: 1,
  //       };
  //     } else {
  //       return {
  //         color,
  //         weight: 2,
  //       };
  //     }
  //   }

  //   if (geometryType === "Point") {
  //     return null; // Prevent 'style' from being applied to Points
  //   } else
  //     return {
  //       color: "#3388ff", // example
  //       weight: 3,
  //     };
  // };

  const getStyleForSvg = (svgFileName, geometryType) => {
    const color =
      svgFileName.match(/(red|green|yellow|black|gray|purple)/i)?.[0] ||
      "#000";

    // console.log("Applying style for:", svgFileName, "Geometry:", geometryType);   

    if (geometryType === "Polygon" || geometryType === "MultiPolygon") {
      if (svgFileName.includes("128_Restricted_Area")) {
        return {
          fill: false,
          fillOpacity: 0,
          fillColor: "transparent",
          color: "red",
          weight: 2,
        };
      } else if (svgFileName.includes(`${color}_fill`)) {
        return {
          fillColor: color,
          color: color,
          weight: 2,
          fillOpacity: 1,
        };
      } else if (svgFileName.includes(`outline_${color}`)) {
        return {
          fill: false,
          fillOpacity: 0,
          fillColor: "transparent",
          color,
          weight: 4,
        };
      }
      else if (svgFileName.includes("AOI")) {
        return {
          fill: false,
          fillOpacity: 0,
          fillColor: "transparent",
          color: "purple",
          weight: 2,
        };
      } else if (svgFileName.includes("hashed_black")) {
        return {
          fill: false,
          fillOpacity: 0,
          fillColor: "transparent",
          color: "#000",
          weight: 2,
        };
      } else if (svgFileName.includes("primary_areas")) {
        return {
          fillColor: "gray",
          color: "#000",
          weight: 2,
          fillOpacity: 0.7,
        };
      } else if (svgFileName.includes("128_Restricted_Area")) {
        return {
          fill: false,
          fillOpacity: 0,
          color: "#fc7c7c",
          weight: 0.5,
        };
      } else if (svgFileName.includes("Area")) {
        return {
          fillColor: "#fc7c7c",
          color: "#ec2d34",
          weight: 3,
          fillOpacity: 0.6,
        };
      } else if (svgFileName.includes("gradient_plasma")) {
        return {
          fill: false,
          fillOpacity: 0,
          fillColor: "transparent",
          color: "#000",
          weight: 1,
        };
      } else if (svgFileName.includes("OFZ")) {
        return {
          fillColor: "#9391fa",
          color: "#393852",
          weight: 1.5,
          fillOpacity: 1,
        };
      }
      else if (svgFileName.includes("simple_blue_")) {
        return {
          fillColor: "#2c5f8f",
          color: "#2c5f8f",
          weight: 2,
          fillOpacity: 0.8,
        };
      }
      else if (svgFileName.includes("outline_blue")) {
        return {
          fill: false,
          fillOpacity: 0,
          fillColor: "transparent",
          color: "#1e4e73",
          weight: 5,
        };
      }
    }

    if (
      geometryType === "LineString" ||
      geometryType === "MultiLineString" ||
      geometryType === "Line" ||
      geometryType === "Polyline"
    ) {
      if (svgFileName.includes("centreline")) {
        return {
          color: "#D3D3D3",
          weight: 2,
          dashArray: "20, 10, 4, 12",
        };
      } else if (svgFileName.includes("construction_lines")) {
        return {
          color: "red",
          weight: 2,
        };
      } else if (
        svgFileName.includes("dash") &&
        svgFileName.includes("black")
      ) {
        return {
          color: "black",
          weight: 4,
          dashArray: "25, 18",
        };
      } else if (
        svgFileName.includes("dash") &&
        svgFileName.includes("green")
      ) {
        return {
          color: "green",
          weight: 4,
          dashArray: "25, 18",
        };
      } else if (svgFileName.includes("dash")) {
        return {
          color,
          weight: 2,
          dashArray: "25, 18",
        };
      } else if (svgFileName.includes("runway")) {
        return {
          color: "#541404",
          weight: 3,
          dashArray: "10, 10",
        };
      } else if (svgFileName.includes("scale_break")) {
        return {
          color: "#541404",
          weight: 4,
        };
      } else if (svgFileName.includes("simple line")) {
        return {
          color,
          weight: 3,
        };
      } else if (svgFileName.includes("wavy line")) {
        return {
          color: "#000",
          weight: 1,
        };
      } else {
        return {
          color,
          weight: 2,
        };
      }
    }

    if (geometryType === "Point") {
      return null;
    }

    // Fallback for any unknown type
    return {
      color: "#3388ff",
      weight: 3,
    };
  };

  //   const handleSvgClick = (svgPath) => {
  //     setLastSvgPath(svgPath);

  //     const fileName = svgPath.split("/").pop();

  //     if (!map || !layerData?.features?.length) {
  //       console.error("Map or layerData not available");
  //       return;
  //     }

  //     //  Remove previously applied symbology layer if it exists
  //     if (window.__symbologyLayers?.[selectedVector] && map.hasLayer(window.__symbologyLayers[selectedVector])) {
  //       map.removeLayer(window.__symbologyLayers[selectedVector]);
  //       console.log(`Removed old symbology for ${selectedVector}`);
  //     }

  //     const legendItem = document.getElementById(`legend-${selectedVector}`);
  //     if (legendItem) legendItem.remove();


  //     const styledGeoJson = {
  //       type: "FeatureCollection",
  //       features: layerData.features.map((feature) => ({
  //         ...feature,
  //       })),
  //     };

  //     const newLayer = L.geoJSON(styledGeoJson, {
  //       style: (feature) => {
  //         const geometryType = getGeometryCategory(feature.geometry.type);
  //         return geometryType === "Point"
  //           ? null
  //           : getStyleForSvg(fileName, geometryType);
  //       },
  //       pointToLayer: (feature, latlng) => {
  //         const geometryType = getGeometryCategory(feature.geometry.type);
  //         if (geometryType === "Point") {
  //           return L.marker(latlng, {
  //             icon: L.icon({
  //               iconUrl: `${process.env.PUBLIC_URL}/Point/${fileName}`,
  //               iconSize: [pointSize, pointSize],
  //               iconAnchor: [pointSize / 2, pointSize / 2],
  //               popupAnchor: [0, -32],
  //             }),
  //           });
  //         }
  //         return null;
  //       },
  //     });

  //     newLayer.addTo(map);

  //     // Save reference
  //     if (!window.__symbologyLayers) window.__symbologyLayers = {};
  //     window.__symbologyLayers[selectedVector] = newLayer;
  //     setGeoJsonLayer(newLayer);

  //     // let legendContent = `
  //     //   <div style="display: flex; align-items: center; gap: 10px;">
  //     //     <img src="${process.env.PUBLIC_URL}/${category}/${fileName}" width="30" height="30" />
  //     //     <span style="font-size: 13px;"><strong>${selectedVector}</strong></span>
  //     //   </div>
  //     // `;

  //     let legendContent = `
  //   <div id="legend-${selectedVector}" style="display: flex; align-items: center; gap: 10px;">
  //     <img src="${process.env.PUBLIC_URL}/${category}/${fileName}" width="30" height="30" />
  //     <span style="font-size: 13px;"><strong>${selectedVector}</strong></span>
  //   </div>
  // `;


  //     if (map && map._showLegend !== false) {
  //       addLegendToMap(map, legendContent, "legend");
  //     }
  //   };

  

  // 5-01-2026
  // const handleSvgClick = (svgPath) => {
  //   setLastSvgPath(svgPath);
  //   const fileName = svgPath.split("/").pop();

  //   if (!map || !layerData?.features?.length) return;

  //   const layerKey = selectedVector;
  //   console.log("layerKey", layerKey);
  //   const legendId = `legend-${layerKey}`;
  //   console.log("legendId", legendId);

  //   // Remove previous symbology for this layer
  //   if (window.__symbologyLayers?.[layerKey] && map.hasLayer(window.__symbologyLayers[layerKey])) {
  //     map.removeLayer(window.__symbologyLayers[layerKey]);
  //   }
  //   // const legendItem = document.getElementById(`legend-${layerKey}`);
  //   // if (legendItem) legendItem.remove();

  //   // const oldLegend = document.querySelector(`[data-legend-id="${legendId}"]`);
  //   // if (oldLegend) oldLegend.remove();

  //   // const styledGeoJson = {
  //   //   type: "FeatureCollection",
  //   //   features: layerData.features.map(f => ({ ...f })),
  //   // };

  //   const styledGeoJson = {
  //     type: "FeatureCollection",
  //     features: layerData.features.map(f => ({
  //       ...f,
  //       properties: {
  //         ...f.properties,
  //         __symbology: {
  //           type: "svg-marker",
  //           iconUrl: `${process.env.PUBLIC_URL}/Point/${fileName}`,
  //           size: pointSize,
  //           anchor: [pointSize / 2, pointSize / 2],
  //         },
  //       },
  //     })),
  //   };
    

  //   const newLayer = L.geoJSON(styledGeoJson, {
  //     style: feature => getGeometryCategory(feature.geometry.type) === "Point"
  //       ? null
  //       : getStyleForSvg(fileName, getGeometryCategory(feature.geometry.type)),
  //     pointToLayer: (feature, latlng) => {
  //       if (getGeometryCategory(feature.geometry.type) === "Point") {
  //         return L.marker(latlng, {
  //           icon: L.icon({
  //             iconUrl: `${process.env.PUBLIC_URL}/Point/${fileName}`,
  //             iconSize: [pointSize, pointSize],
  //             iconAnchor: [pointSize / 2, pointSize / 2],
  //           }),
  //         });
  //       }
  //       return null;
  //     },
  //   }).addTo(map);

  //   if (!window.__symbologyLayers) window.__symbologyLayers = {};
  //   window.__symbologyLayers[layerKey] = newLayer;

  //   setGeoJsonLayer(newLayer);

  //   const legendContent = `
  //   <div id="legend-${layerKey}" style="display:flex;align-items:center;gap:10px;">
  //     <img src="${process.env.PUBLIC_URL}/${category}/${fileName}" width="30" height="30"/>
  //     <span style="font-size:13px;"><strong>${selectedVector}</strong></span>
  //   </div>
  // `;
  //   // if (map && map._showLegend !== false) addLegendToMap(map, legendContent, "legend");

  //   if (map && map._showLegend !== false) {
  //     addLegendToMap(map, legendContent, legendId);
  //   }

  // };

  useEffect(() => {
    window.__originalLayers ||= {};
    window.__symbologyLayers ||= {};
  }, []);
  

  // const handleSvgClick = (svgPath) => {
  //   const fileName = svgPath.split("/").pop();
  //   if (!selectedVector || !Canvas.layerData[selectedVector]) return;
  
  //   const geojson = Canvas.layerData[selectedVector];
  
  //   // 1️⃣ Inject symbology into data
  //   const updated = {
  //     ...geojson,
  //     features: geojson.fegeoseratures.map(f => ({
  //       ...f,
  //       properties: {
  //         ...f.properties,
  //         __symbology: {
  //           type: "svg-marker",
  //           iconUrl: `${process.env.PUBLIC_URL}/Point/${fileName}`,
  //           size: Number(pointSize),
  //         }
  //       }
  //     }))
  //   };
  
  //   // 2️⃣ Persist it
  //   Canvas.layerData[selectedVector] = updated;
  
  //   // 3️⃣ Re-render SAME layer
  //   Canvas.addLocalLayer(
  //     selectedVector,
  //     updated,
  //     Canvas.layers_color[selectedVector],
  //     null,
  //     true
  //   );
  // };
  

  // const handleSvgClick = (svgPath) => {
  //   if (!selectedVector || !Canvas.layerData[selectedVector]) return;
  
  //   const fileName = svgPath.split("/").pop();
  //   const geojson = Canvas.layerData[selectedVector];
  
  //   // Inject symbology
  //   geojson.features.forEach(f => {
  //     f.properties = f.properties || {};
  //     f.properties.__symbology = {
  //       type: "svg-marker",
  //       iconUrl: `${process.env.PUBLIC_URL}/Point/${fileName}`,
  //       size: Number(pointSize) || 24,
  //     };
  //   });
  
  //   Canvas.layerData[selectedVector] = geojson;
  
  //   // Update layer in-place
  //   const layer = Canvas._deck.props.layers.find(l => l.id === selectedVector);
  //   if (!layer) return;
  
  //   const updatedLayer = layer.clone({
  //     data: geojson,
  //     pointType: "icon",        // make sure it's treated as an icon
  //     mode: ViewMode,           // ensure icons are visible
  //     selectedFeatureIndexes: Canvas.selectedFeatureIndexes[selectedVector] || [],
  //     getIcon: f => {
  //       const sym = f.properties?.__symbology;
  //       if (!sym) return null;
  //       return {
  //         url: sym.iconUrl,
  //         width: Number(sym.size),
  //         height: Number(sym.size),
  //         anchorX: Number(sym.size) / 2,
  //         anchorY: Number(sym.size),
  //       };
  //     }
  //   });
  
  //   Canvas._deck.setProps({
  //     layers: Canvas._deck.props.layers.map(l =>
  //       l.id === selectedVector ? updatedLayer : l
  //     )
  //   });
  // };


  // April 5 - Shakshi Agarwal - Updated handleSvgClick 

// April 5 - Shakshi Agarwal - Updated handleSvgClick 

// const handleSvgClick = (svgPath) => {
//   setLastSvgPath(svgPath);
//   const fileName = svgPath.split("/").pop();

//   if (selectedVector && map && Canvas) {
//     try {
//       const originalLayer = Canvas.getLeafletLayer
//         ? Canvas.getLeafletLayer(selectedVector)
//         : null;

//       if (originalLayer && map.hasLayer(originalLayer)) {
//         map.removeLayer(originalLayer);
//       }
//     } catch (err) {
//       console.warn("Could not hide original layer:", err);
//     }
//   }

//   if (!map || !layerData?.features?.length) {
//     console.error("Map or layerData not available");
//     return;
//   }

//   if (window.__symbologyLayers?.[selectedVector]) {
//     const old = window.__symbologyLayers[selectedVector];
//     if (map.hasLayer(old)) map.removeLayer(old);
//     delete window.__symbologyLayers[selectedVector];
//   }

//   if (Canvas?._deck?.props?.layers) {
//     Canvas._deck.setProps({
//       layers: Canvas._deck.props.layers.map(l =>
//         l.id === selectedVector ? l.clone({ visible: false }) : l
//       )
//     });
//   }

//   const size = Number(pointSize) || 35;

//   const newLayer = L.geoJSON(layerData, {
//     style: (feature) => {
//       const geometryType = getGeometryCategory(feature.geometry.type);
//       return geometryType === "Point" ? null : getStyleForSvg(fileName, geometryType);
//     },
//     pointToLayer: (feature, latlng) => {
//       if (getGeometryCategory(feature.geometry.type) === "Point") {
//         return L.marker(latlng, {
//           icon: L.icon({
//             iconUrl: `${process.env.PUBLIC_URL}/Point/${fileName}`,
//             iconSize: [size, size],
//             iconAnchor: [size / 2, size / 2],
//             popupAnchor: [0, -size / 2],
//           }),
//         });
//       }
//       return null;
//     },
//   }).addTo(map);

//   if (!window.__symbologyLayers) window.__symbologyLayers = {};
//   window.__symbologyLayers[selectedVector] = newLayer;

//   // ✅ KEY FIX: update UsedLayers so checkbox toggle controls this layer
//   SetLayers(prev => ({ ...prev, [selectedVector]: newLayer }));

//   setGeoJsonLayer(newLayer);

//   const legendContent = `
//     <div id="legend-${selectedVector}" style="display:flex;align-items:center;gap:10px;">
//       <img src="${process.env.PUBLIC_URL}/${category}/${fileName}" width="30" height="30"/>
//       <span style="font-size:13px;"><strong>${selectedVector}</strong></span>
//     </div>
//   `;
//   if (map && map._showLegend !== false) {
//     addLegendToMap(map, legendContent, `legend-${selectedVector}`);
//   }
// };

//Final version
// const handleSvgClick = (svgPath) => {
//   setLastSvgPath(svgPath);
//   const fileName = svgPath.split("/").pop();
//   const layerKey = selectedVector;

//   // ✅ Hide Deck.gl layers (blue points)
//   if (Canvas?._deck?.props?.layers) {
//     Canvas._deck.setProps({
//       layers: Canvas._deck.props.layers.map((l) => {
//         if (l.props?.data) {
//           return l.clone({ visible: false });
//         }
//         return l;
//       }),
//     });
//   }

//   if (!map || !layerData?.features?.length) {
//     console.error("Map or layerData not available");
//     return;
//   }

//   // ✅ Remove old symbology layer for this original layer name
//   if (window.__symbologyLayers?.[layerKey]) {
//     const old = window.__symbologyLayers[layerKey];
//     if (map.hasLayer(old)) map.removeLayer(old);
//     delete window.__symbologyLayers[layerKey];
//   }

//   const size = Number(pointSize) || 35;

//   const newLayer = L.geoJSON(layerData, {
//     style: (feature) => {
//       const geometryType = getGeometryCategory(feature.geometry.type);
//       return geometryType === "Point"
//         ? null
//         : getStyleForSvg(fileName, geometryType);
//     },
//     pointToLayer: (feature, latlng) => {
//       if (getGeometryCategory(feature.geometry.type) === "Point") {
//         return L.marker(latlng, {
//           icon: L.icon({
//             iconUrl: `${process.env.PUBLIC_URL}/Point/${fileName}`,
//             iconSize: [size, size],
//             iconAnchor: [size / 2, size / 2],
//             popupAnchor: [0, -size / 2],
//           }),
//         });
//       }
//       return null;
//     },
//   }).addTo(map);

//   if (!window.__symbologyLayers) window.__symbologyLayers = {};
//   window.__symbologyLayers[layerKey] = newLayer;

//   // SetLayers((prev) => ({
//   //   ...prev,
//   //   [layerKey]: newLayer,
//   // }));
//   const layerEntry = Object.values(layerControls._layers).find(
//   (l) => l.name === layerKey || l.orgname === layerKey
// );

// if (layerEntry) {
//   const oldLayer = layerEntry.layer;

//   if (map.hasLayer(oldLayer)) {
//     map.removeLayer(oldLayer);
//   }

//   layerControls.removeLayer(oldLayer);
//   layerControls.addOverlay(newLayer, layerKey);
  
// }

//   setGeoJsonLayer(newLayer);

//   const legendContent = `
//     <div id="legend-${layerKey}" style="display:flex;align-items:center;gap:10px;">
//       <img src="${process.env.PUBLIC_URL}/${category}/${fileName}" width="30" height="30"/>
//       <span style="font-size:13px;"><strong>${layerKey}</strong></span>
//     </div>
//   `;

//   if (map && map._showLegend !== false) {
//     addLegendToMap(map, legendContent, `legend-${layerKey}`);
//   }
// };

  // const handleNoneStyle = () => {
  //   if (!selectedVector || !Canvas.layerData[selectedVector]) return;
  
  //   const geojson = Canvas.layerData[selectedVector];
  
  //   // Remove symbology
  //   geojson.features.forEach(f => {
  //     if (f.properties) delete f.properties.__symbology;
  //   });
  
  //   Canvas.layerData[selectedVector] = geojson;
  
  //   // Update layer in-place
  //   const layer = Canvas._deck.props.layers.find(l => l.id === selectedVector);
  //   if (!layer) return;
  
  //   const updatedLayer = layer.clone({
  //     data: geojson,
  //     selectedFeatureIndexes: Canvas.selectedFeatureIndexes[selectedVector] || [],
  //     mode: Canvas.editMode ? ModifyMode : ViewMode,
  //   });
  
  //   Canvas._deck.setProps({
  //     layers: Canvas._deck.props.layers.map(l => 
  //       l.id === selectedVector ? updatedLayer : l
  //     )
  //   });
  // };


//   const handleSvgClick = (svgPath) => {
//   setLastSvgPath(svgPath);
//   const fileName = svgPath.split("/").pop();

//   // ✅ CHANGE 1: make key UNIQUE (so it doesn't overwrite)
//   const layerKey = `${selectedVector}`;

//   // ✅ Hide Deck.gl layers (blue points)
//   if (Canvas?._deck?.props?.layers) {
//     Canvas._deck.setProps({
//       layers: Canvas._deck.props.layers.map((l) => {
//         if (l.props?.data) {
//           return l.clone({ visible: false });
//         }
//         return l;
//       }),
//     });
//   }

//   if (!map || !layerData?.features?.length) {
//     console.error("Map or layerData not available");
//     return;
//   }

//   // ✅ CHANGE 2: support MULTIPLE entries instead of single
//   if (!window.__symbologyLayers) window.__symbologyLayers = {};

//   if (!window.__symbologyLayers[selectedVector]) {
//     window.__symbologyLayers[selectedVector] = [];
//   }

//   const size = Number(pointSize) || 35;

//   // ✅ REMOVE previous symbology for THIS vector only
// if (window.__symbologyLayers?.[selectedVector]) {
//   window.__symbologyLayers[selectedVector].forEach((entry) => {
//     if (map.hasLayer(entry.layer)) {
//       map.removeLayer(entry.layer);
//     }
//   });

//   // clear old entries
//   window.__symbologyLayers[selectedVector] = [];
// }

//   const newLayer = L.geoJSON(layerData, {
//     style: (feature) => {
//       const geometryType = getGeometryCategory(feature.geometry.type);
//       return geometryType === "Point"
//         ? null
//         : getStyleForSvg(fileName, geometryType);
//     },
//     pointToLayer: (feature, latlng) => {
//       if (getGeometryCategory(feature.geometry.type) === "Point") {
//         return L.marker(latlng, {
//           icon: L.icon({
//             iconUrl: `${process.env.PUBLIC_URL}/Point/${fileName}`,
//             iconSize: [size, size],
//             iconAnchor: [size / 2, size / 2],
//             popupAnchor: [0, -size / 2],
//           }),
//         });
//       }
//       return null;
//     },
//   }).addTo(map);

//   // ✅ store multiple layers
//   window.__symbologyLayers[selectedVector].push({
//     key: layerKey,
//     layer: newLayer,
//   });

//   // ❗ KEEP YOUR ORIGINAL LOGIC (unchanged)
//   const layerEntry = Object.values(layerControls._layers).find(
//     (l) => l.name === selectedVector || l.orgname === selectedVector
//   );

//   if (layerEntry) {
//     const oldLayer = layerEntry.layer;

//     if (map.hasLayer(oldLayer)) {
//       map.removeLayer(oldLayer);
//     }

//     // layerControls.removeLayer(oldLayer);
//     layerControls.addOverlay(newLayer, layerKey);
//   }

//   setGeoJsonLayer(newLayer);

//   const legendContent = `
//     <div id="legend-${layerKey}" style="display:flex;align-items:center;gap:10px;">
//       <img src="${process.env.PUBLIC_URL}/${category}/${fileName}" width="30" height="30"/>
//       <span style="font-size:13px;"><strong>${layerKey}</strong></span>
//     </div>
//   `;

//   if (map && map._showLegend !== false) {
//     addLegendToMap(map, legendContent, `legend-${layerKey}`);
//   }
// };


const handleSvgClick = (svgPath) => {
  setLastSvgPath(svgPath);
  const fileName = svgPath.split("/").pop();

  const layerKey = `${selectedVector}`;

  if (Canvas?._deck?.props?.layers) {
    Canvas._deck.setProps({
      layers: Canvas._deck.props.layers.map((l) => {
        if (l.props?.data) {
          return l.clone({ visible: false });
        }
        return l;
      }),
    });
  }

  if (!map || !layerData?.features?.length) return;

  window.__symbologyLayers ||= {};

  // ✅ remove old symbology
  if (window.__symbologyLayers[selectedVector]) {
    const oldLayer = window.__symbologyLayers[selectedVector];
    if (map.hasLayer(oldLayer)) {
      map.removeLayer(oldLayer);
    }
  }

  const size = Number(pointSize) || 35;

  const newLayer = L.geoJSON(layerData, {
    style: (feature) => {
      const geometryType = getGeometryCategory(feature.geometry.type);
      return geometryType === "Point"
        ? null
        : getStyleForSvg(fileName, geometryType);
    },
    pointToLayer: (feature, latlng) => {
      if (getGeometryCategory(feature.geometry.type) === "Point") {
        return L.marker(latlng, {
          icon: L.icon({
            iconUrl: `${process.env.PUBLIC_URL}/Point/${fileName}`,
            iconSize: [size, size],
            iconAnchor: [size / 2, size / 2],
            popupAnchor: [0, -size / 2],
          }),
        });
      }
    },
  }).addTo(map);


  window.__symbologyLayers[selectedVector] = newLayer;


  const layerEntry = Object.values(layerControls._layers).find(
    (l) => l.name === selectedVector
  );

  if (layerEntry) {
    layerControls.removeLayer(layerEntry.layer);
  }

  layerControls.addOverlay(newLayer, selectedVector);

  setGeoJsonLayer(newLayer);

  const legendContent = `
    <div id="legend-${layerKey}" style="display:flex;align-items:center;gap:10px;">
      <img src="${process.env.PUBLIC_URL}/${category}/${fileName}" width="30" height="30"/>
      <span style="font-size:13px;"><strong>${layerKey}</strong></span>
    </div>
  `;

  if (map && map._showLegend !== false) {
    addLegendToMap(map, legendContent, `legend-${layerKey}`);
  }
};


 
  const removeOldPaths = () => {
    const svgContainer = map.getPanes().overlayPane.querySelector("svg");
    if (svgContainer) {
      const paths = svgContainer.querySelectorAll("path");
      paths.forEach((path) => {
        path.remove();
      });
    }
  };

  // Function to remove all styles and cleanup layer
  // const handleNoneStyle = () => {
  //   console.log("selected vector", selectedVector);

  //   if (window.__symbologyLayers?.[selectedVector] && map.hasLayer(window.__symbologyLayers[selectedVector])) {
  //     map.removeLayer(window.__symbologyLayers[selectedVector]);
  //     delete window.__symbologyLayers[selectedVector];
  //     console.log(`Cleared symbology for ${selectedVector}`);
  //   }

  //   // ✅ Remove legend for this vector only
  //   const legendItem = document.getElementById(`legend-${selectedVector}`);
  //   if (legendItem) legendItem.remove();
  // };




  // const handleNoneStyle = () => {
  //   const layerKey = selectedVector;
  //   const legendId = `legend-${layerKey}`;

  //   if (window.__symbologyLayers?.[layerKey] && map.hasLayer(window.__symbologyLayers[layerKey])) {
  //     map.removeLayer(window.__symbologyLayers[layerKey]);
  //     delete window.__symbologyLayers[layerKey];
  //     console.log(`Cleared symbology for ${selectedVector}`);
  //   }

  //   // const legendItem = document.getElementById(`legend-${layerKey}`);
  //   // if (legendItem) legendItem.remove();

  //   const legendItem = document.querySelector(`[data-legend-id="${legendId}"]`);
  //   if (legendItem) legendItem.remove();

  // };


  // const handleNoneStyle = () => {
  //   if (!selectedVector || !Canvas.layerData[selectedVector]) return;
  
  //   const geojson = Canvas.layerData[selectedVector];
  
  //   const cleared = {
  //     ...geojson,
  //     features: geojson.features.map(f => {
  //       const p = { ...f.properties };
  //       delete p.__symbology;
  //       return { ...f, properties: p };
  //     })
  //   };
  
  //   Canvas.layerData[selectedVector] = cleared;
  
  //   Canvas.addLocalLayer(
  //     selectedVector,
  //     cleared,
  //     Canvas.layers_color[selectedVector],
  //     null,
  //     true
  //   );
  // };
  

  // April 5 - Shakshi Agarwal - Updated handleNoneStyle 

      const handleNoneStyle = () => {
      if (window.__symbologyLayers?.[selectedVector]) {
        const old = window.__symbologyLayers[selectedVector];
        if (map.hasLayer(old)) map.removeLayer(old);
        delete window.__symbologyLayers[selectedVector];
      }

      // Restore deck.gl layer visibility
      if (Canvas?._deck?.props?.layers) {
        Canvas._deck.setProps({
          layers: Canvas._deck.props.layers.map(l =>
            l.id === selectedVector ? l.clone({ visible: true }) : l
          )
        });
      }

      // ✅ Restore original layer reference in UsedLayers
      // The deck.gl layer is now visible again, clear the Leaflet override
      SetLayers(prev => {
        const updated = { ...prev };
        delete updated[selectedVector];
        return updated;
      });

      const legendItem = document.getElementById(`legend-${selectedVector}`);
      if (legendItem) legendItem.remove();
      setGeoJsonLayer(null);
      setLastSvgPath(null);
    };

  return (
    <div
      className="text-dark"
      style={{ overflow: "hidden", overflowY: "scroll" }}
    >
      <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
        <select
          className="form-select mt-2 swipe-options"
          style={{
            marginBottom: "5px",
            backgroundColor: "transparent",
            fontSize: "13px",
          }}
          value={selectedVector}
          onChange={(e) => {
            setSelectedVector(e.target.value);
          }}
        >
          <option
            value=""
            style={{
              marginBottom: "5px",
              backgroundColor: "transparent",
              fontSize: "13px",
            }}
          >
            Select Layer
          </option>

          {availableVectors.map((comp) => (
            <option
              key={comp}
              value={comp}
              style={{
                marginBottom: "5px",
                backgroundColor: "transparent",
                fontSize: "13px",
              }}
            >
              {comp}
            </option>
          ))}
        </select>


        {category === "Point" && (
          <input
            type="number"
            className="form-control"
            placeholder="Icon Size"
            value={pointSize}
            onChange={(e) => setPointSize(e.target.value)}
          />
        )}


      </div>

      {layerData?.features?.length > 0 ? (
        <>
          <div
            className="svg-list"
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "20px",
              padding: "20px",
            }}
          >
            <div
              style={{
                textAlign: "center",
                width: 100,
                height: 100,
                margin: "0 20px",
                border: "1px solid #ccc",
                alignContent: "center",
              }}
              onClick={handleNoneStyle}
            >
              {/* <i
                class="fa-solid fa-ban"
                style={{
                  fontSize: "30px",
                  marginTop: "30px",
                
                }}
                onClick={handleNoneStyle}
              ></i> */}
              None
            </div>
            {publicSvgList.map((svgPath, idx) => (
              <>
                <img
                  key={idx}
                  src={svgPath}
                  alt={`SVG ${idx + 1}`}
                  className="symbology-svg"
                  onClick={() => handleSvgClick(svgPath)} // Trigger style application on click
                  style={{
                    cursor: "pointer",
                    width: 100,
                    height: 100,
                    margin: "0 20px",
                  }}
                />
              </>
            ))}
          </div>

          {/* <button onClick={handleNoneStyle} style={{ marginTop: 10 }}>
            Remove Style
          </button> */}
        </>
      ) : (
        <p>No features available</p>
      )}
    </div>
  );
}